import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const getAssetUrlWithTempLocationSupport = (url: string) =>
  url.startsWith('temp/') ? `${window.location.origin}/${url}` : url;

export const questionnaireAssetApi = createApi({
  reducerPath: 'questionnaireAssetApi',
  // Setting Content-Type = text/plain header worked fine for Firebase Hosting but for
  // Firebase storage it causes 403 error with "SignatureDoesNotMatch" message in response payload.
  // File content type can be set to text/plain in GCP console (upload recognizes .castor fileas
  // application/octet-stream)
  baseQuery: fetchBaseQuery(),
  endpoints: builder => ({
    getProseDslSourceByAssetId: builder.query<string, string>({
      query: url => {
        // TODO: Error detection (distinguish HTML error message from valid DSL payload
        return {
          url: getAssetUrlWithTempLocationSupport(url),
          responseHandler: 'text',
        };
      },
      keepUnusedDataFor: Infinity,
    }),
  }),
});

export const { endpoints: questionnaireAssetApiEndpoints } =
  questionnaireAssetApi;

export const { useGetProseDslSourceByAssetIdQuery } = questionnaireAssetApi;
